'use es6';

import PropTypes from 'prop-types';
import { BreakString } from 'foundations-components/transitional/components/BreakString';
import SanitizedText from 'sanitize-text/components/SanitizedText';
import { jsx as _jsx } from "react/jsx-runtime";
const Benefits = ({
  benefits
}) => /*#__PURE__*/_jsx(BreakString, {
  children: /*#__PURE__*/_jsx(SanitizedText, {
    body: benefits
  })
});
Benefits.propTypes = {
  benefits: PropTypes.string.isRequired
};
export default Benefits;